import type { PlayerEvent, PlayerEventPayload } from "./interface.js";

export class PlayerEventEmitter {
  private readonly listeners = new Map<PlayerEvent, Set<(payload: PlayerEventPayload) => void>>();

  on(event: PlayerEvent, callback: (payload: PlayerEventPayload) => void): () => void {
    const callbacks = this.listeners.get(event) ?? new Set();
    callbacks.add(callback);
    this.listeners.set(event, callbacks);
    return () => callbacks.delete(callback);
  }

  emit(event: PlayerEvent, payload: PlayerEventPayload): void {
    for (const callback of this.listeners.get(event) ?? []) callback(payload);
  }

  clear(): void {
    this.listeners.clear();
  }
}
